import type { FC } from 'react'
import { Paper, Typography, Box, Chip, Tooltip } from '@mui/material'

interface ReviewRewardCardProps {
  rewardName: string
  supportsEmployeeContribution: boolean
  companyContribution: number
  employeeContribution: number
}

export const ReviewRewardCard: FC<ReviewRewardCardProps> = ({
  rewardName,
  supportsEmployeeContribution,
  companyContribution,
  employeeContribution,
}) => {
  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{
        px: 1.5,
        py: 0.5,
        mb: 0.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box sx={{ flexGrow: 1, minWidth: 120 }}>
        <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
          {rewardName}
        </Typography>
      </Box>

      {supportsEmployeeContribution && (
        <Tooltip title="Employee Contribution Allowed">
          <Chip label="EC" size="small" color="primary" sx={{ height: 18, fontSize: '0.65rem', fontWeight: 600 }} />
        </Tooltip>
      )}

      <Box sx={{ width: 140, textAlign: 'right', pr: 2 }}>
        <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
          ${companyContribution.toLocaleString()}
        </Typography>
      </Box>

      <Box sx={{ width: 140, textAlign: 'right', pr: 2 }}>
        <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
          ${employeeContribution.toLocaleString()}
        </Typography>
      </Box>
    </Paper>
  )
}
